import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modalState: false,
  learnerUpdateAction: null,
  selectedSuperBatch: null,
  learnerEmails: '',
  pastClassesStatus: null,
  batchSequence: null,
  moduleRepeat: false,
};

const editCrashCourseBatch = createSlice({
  name: 'editCrashCourseBatch',
  initialState,
  reducers: {
    setEditCrashCourseBatchModalState(state, action) {
      state.modalState = action.payload;
    },
    setLearnerUpdateAction(state, action) {
      state.learnerUpdateAction = action.payload;
    },
    setSelectedSuperBatch(state, action) {
      state.selectedSuperBatch = action.payload;
    },
    setLearnerEmails(state, action) {
      state.learnerEmails = action.payload;
    },
    setBatchSequence(state, action) {
      state.batchSequence = action.payload;
    },
    setModuleRepeat(state, action) {
      state.moduleRepeat = action.payload;
    },
    setPastClassesStatus(state, action) {
      state.pastClassesStatus = action.payload;
    },
    resetEditCrashCourseBatch(state) {
      for (const key in initialState) {
        state[key] = initialState[key];
      }
    },
  },
});

export const {
  setEditCrashCourseBatchModalState,
  setLearnerUpdateAction,
  setSelectedSuperBatch,
  setLearnerEmails,
  setPastClassesStatus,
  resetEditCrashCourseBatch,
  setBatchSequence,
  setModuleRepeat,
} = editCrashCourseBatch.actions;

export default editCrashCourseBatch.reducer;
